module.exports = __webpack_public_path__ + "static/media/favicon.9ada142d.ico";